/**
 * 数据看板下的总览
 */
 import httpRequest from '@/utils/request.js';

 /**总览设备列表 */
export const getDeviceList = (params = {}) =>
httpRequest.httpGet({
    url: `/service/overview/device/lst`,
    params
});
 /**总览设备详细 */
 export const getDeviceDetail = (type, params = {}) =>
 httpRequest.httpGet({
     url: `/service/overview/device/${type}/detail`,
     params
 });
  /**总览监测点列表 */
export const getCarrierList = (params = {}) =>
httpRequest.httpGet({
    url: `/service/overview/carrier/lst`,
    params
});
  /**总览监测点详细 */
  export const getCarrierDetail = (params = {}) =>
  httpRequest.httpGet({
      url: `/service/overview/carrier/detail`,
      params
  });
/**获取监测点数据上报及时率 */
export const getTimelyRate = (params = {}) =>
httpRequest.httpGet({
    url: `/service/overview/carrier/timely`,
    params
});
/**获取监测点数据上报达标率 */
export const getStandardRate = (params = {}) =>
    httpRequest.httpGet({
    url: `/service/overview/carrier/standard`,
    params
});
  /**总览报警列表 */
export const getAlarmList = (params = {}) =>
  httpRequest.httpGet({
      url: `/service/overview/alarm/lst`,
      params
  });
/**总览报警信息详情 */
export const getAlarmDetail = (params = {}) =>
httpRequest.httpGet({
    url: `/service/overview/alarm/detail`,
    params
});
/**总览异常次数列表 */
export const getExNumList = (params = {}) =>
httpRequest.httpGet({
    url: `/service/overview/ex/num/lst`,
    params
});
/**总览异常时间列表 */
export const getExTimeList = (params = {}) =>
httpRequest.httpGet({
    url: `/service/overview/ex/time/lst`,
    params
});
/**总览异常次数详情 */
export const getExNumDetail = (params = {}) =>
httpRequest.httpGet({
    url: `/service/overview/ex/num/detail`,
    params
});
/**总览异常时间详情 */
export const getExTimeDetail = (params = {}) =>
httpRequest.httpGet({
    url: `/service/overview/ex/time/detail`,
    params
});
